import React from 'react';
import cn from './style.module.scss';
import DynamicTabs from '@components/DynamicTabs';
import WaldorfContainer from '@launch-components/WaldorfAstoriaLaunch/WaldorfContainer';
import {ImageObj} from '@custom-types/ImageObj.types';
import TabProperties from './TabProperties';
import TabAstoria from './TabAstoria';
interface CompanyTabProps {
  companyContentIcon: {
    properties: ImageObj[];
    astoria: ImageObj[];
  };
  companyTabMobileThemeImage: {
    properties: ImageObj[];
    astoria: ImageObj[];
  };
  companyTabDesktopThemeImage: {
    properties: ImageObj[];
    astoria: ImageObj[];
  };
  t: any;
}
export default function CompanyTab(props: CompanyTabProps) {
  const {t} = props;

  const tabs = [
    {
      title: t['waldorfPropertiesLabel'],
      bgColor: '#272525',
      content: (
        <>
          <TabProperties
            t={t}
            tabImages={props.companyTabMobileThemeImage.properties}
            mobTabImages={props.companyTabDesktopThemeImage.properties}
            contentIcon={props.companyContentIcon.properties}
          />
        </>
      ),
    },
    {
      title: t['waldorfAstoriaLabel'],
      bgColor: '#272525',
      content: (
        <>
          <TabAstoria
            t={t}
            tabImages={props.companyTabMobileThemeImage.astoria}
            mobTabImages={props.companyTabDesktopThemeImage.astoria}
            contentIcon={props.companyContentIcon.astoria}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <WaldorfContainer>
        <DynamicTabs
          tabs={tabs}
          className={cn.waldorfCompany}
          tabClass={cn.companyTabElement}
          activeClassName={cn.activeLink}
        />
      </WaldorfContainer>
    </>
  );
}
